import { render } from "./NewPodcast.vue?vue&type=template&id=210a03a8&scoped=true"
import script from "./NewPodcast.vue?vue&type=script&lang=js"
export * from "./NewPodcast.vue?vue&type=script&lang=js"

import "./NewPodcast.vue?vue&type=style&index=0&id=210a03a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210a03a8"]])

export default __exports__